import { Car } from "./car.model"
import { Company } from "./company.model"
import { Container } from "./container.model"
import { Poligon } from "./poligon.model"
import { SessionLog } from "./session-log.model"
import { Shift } from "./shift.model"

export class DriverProcess {

    public id?: number
    public carId?: number
    public shiftId?: number
    public companyId?: number
    public polygonId?: number
    public polygon?:Poligon
    public allContainerCount?:number
    public fullContainerCount?:number
    public emptyContainerCount?:number
    public estimatedDistance?:string
    public estimatedTime?:string
    public startLat?:string
    public startLng?:string
    public endLat?:string
    public endLng?:string
    public distanceTraveled?:number
    public simulation?:boolean
    public car?: Car
    public shift?: Shift
    public sessionLog?:SessionLog
    public sessionLogId?:number
    public company?: Company
    public startDate?: Date
    public endDate?: Date
    public status?: boolean

}

export class DriverProcessDetail {
    public containerId?: number
    public driverProcessId?: number
    public visitDate?: Date
    public carLat?:string
    public carLng?:string
    public container?:Container
    public status?:DriverProcessDetailEnum
    public driverProcess?:DriverProcess
}

export class DriverProcessHistory{
    id?:number 
    order:number 
    driverProcessId:number 
    containerId:number 
    carId:number 
    container:Container 
    car:Car 
    driverProcess:DriverProcess
    driverProcessDetail:DriverProcessDetail
}
export enum DriverProcessDetailEnum{
    collected = "collected",
    not_collected = "not_collected",
    on_hold = "on_hold"
}